'use strict';

import React, { Component } from 'react';
import ChatOverlayConfirmClose from 'components/ChatOverlayConfirmClose';
import ChatOverlayRequestRating from 'components/ChatOverlayRequestRating';
import ChatOverlayRequestTranscript from 'components/ChatOverlayRequestTranscript';

class ChatOverlayContent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.layout in this.components){
			const MyComponent = this.components[ this.props.layout ];
			return <MyComponent {...this.props} />
		}
		return false;
	}
}

const supportedOverlaysComponents = {
		confirmClose     : ChatOverlayConfirmClose,
		requestRating    : ChatOverlayRequestRating,
		requestTranscript: ChatOverlayRequestTranscript
	},
	supportedOverlays = Object.keys( supportedOverlaysComponents );

ChatOverlayContent.prototype.components = supportedOverlaysComponents;
ChatOverlayContent.displayName = 'ChatOverlayContent';
ChatOverlayContent.propTypes = {
	layout: React.PropTypes.string
};

export default ChatOverlayContent;

export {
	supportedOverlays
}


// WEBPACK FOOTER //
// ./src/components/ChatOverlayContent.js